import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchUsers = async () => {
  const url = `${API_BASE_URL}/users`;
  const response = await axios.get(url, getAuthConfig());

  return response.data?.items || [];
};

export const getUsersRequestUrl = () => `${API_BASE_URL}/users`;
